import styled from 'styled-components';

import { flexColumn } from '@/styles/common';

import { Typography } from '../ui/Typography/Typography.styles';

export const Wrapper = styled.div`
  ${flexColumn};
  justify-content: center;
  padding: 20px;
  width: 344px;
  gap: 20px;
`;

export const ModalActions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Subtitle = styled(Typography).attrs({ variant: 'body2' })`
  color: var(--textAndLabels-tertiary);
`;

export const ContentWrapper = styled.div`
  ${flexColumn};
  align-items: center;
  text-align: center;
  gap: 10px;
`;
